import React, { Component } from 'react';
import { arrayOf, bool, func, number, object, shape, string } from 'prop-types';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import InPlaceIndicator from 'ps-components/LoadingIndicator/InPlaceIndicator/InPlaceIndicator';
import SurveyJobRow from '../../../JobMatching/ResultDetails/SurveyJobRow';
import Table from 'ps-components/Table/Table/Table';
import TableBody from 'ps-components/Table/TableBody/TableBody';
import TableHeader from 'ps-components/Table/TableHeader/TableHeader';
import Pagination from 'ps-components/Pagination/Pagination';
import Placeholder from 'ps-components/Placeholder/Placeholder';
import './SurveyJobMatchingList.scss';

const STEP = 50;
class SurveyJobMatchingList extends Component {
  static propTypes = {
    isSelected: bool,
    loading: bool,
    isLoading: bool,
    pageAction: func,
    searchCriteria: shape({
      orgJobCurrency: string,
      publishers: arrayOf(string),
      surveyCodes: arrayOf(string),
      text: string,
      years: arrayOf(string)
    }),
    selectedJob: shape({
      code: string,
      codeKey: string,
      currency: string,
      description: string,
      descriptionDocument: shape({
        fileLocation: string,
        title: string
      }),
      employeeCount: number,
      id: string,
      jobMatches: arrayOf(
        shape({
          id: string,
          orgJob: shape({
            id: string
          }),
          surveyJob: shape({
            code: string,
            description: string,
            id: string,
            survey: shape({
              code: string,
              id: string,
              name: string
            }),
            title: string
          })
        })
      ),
      name: string
    }),
    selectedJobConnection: arrayOf(
      shape({
        id: string,
        orgJob: shape({
          id: string
        }),
        surveyJob: shape({
          code: string,
          description: string,
          id: string,
          survey: shape({
            code: string,
            id: string,
            name: string
          }),
          title: string
        })
      })
    ),
    showJobDescriptions: bool,
    surveyJobs: arrayOf(
      shape({
        code: string,
        description: string,
        id: string,
        survey: shape({
          code: string,
          id: string,
          name: string
        }),
        title: string
      })
    ),
    totalCount: number,
    toggleJobDescriptions: func,
    updateMatches: func,
    tempMatchSelections: arrayOf(object)
  };

  selectAllSurveyJobs = () => {
    console.log('select all jobs');
  };

  render() {
    const {
      isSelected,
      loaded,
      loading,
      pageAction,
      searchCriteria,
      selectedJob,
      selectedJobConnection,
      showJobDescriptions,
      surveyJobs,
      toggelDescriptions,
      totalCount,
      toggleJobDescriptions,
      updateTempMatches,
      tempMatchSelections
    } = this.props;
    const shouldShowMore = !!surveyJobs.length && surveyJobs.length % STEP === 0 && surveyJobs.length !== totalCount;
    const COLUMNS = [
      <CheckboxInput checked={false} className="select-all__input" onClick={this.selectAllSurveyJobs} />,
      'Survey Jobs',
      <div className="table__column-with-toggle">
        Survey
        <div className="pxl-text-muted pxl-text-xsmall column__data-toggle">
          <CheckboxInput
            checked={showJobDescriptions}
            className="survey__description-toggle"
            onClick={toggleJobDescriptions}
          />
          Show Survey Job Description
        </div>
      </div>
    ];
    const secondaryText = isSelected
      ? 'There are no results for your search.'
      : 'You have not selected any matches for this job.';

    if (surveyJobs.length) {
      return (
        <div className="survey__job-panel-body">
          {!loading && loaded ? (
            <Table>
              <TableHeader
                cellClass="pxl-text-muted pxl-text-xsmall survey__job-table-header-cell"
                columns={COLUMNS}
                headerClass="survey__job-table-header"
              />
              <TableBody className="survey__job-table-body">
                {surveyJobs.map((job, index) => (
                  <SurveyJobRow
                    key={index}
                    showJobDescriptions={showJobDescriptions}
                    selectedJob={selectedJob}
                    selectedJobConnection={selectedJobConnection}
                    surveyJob={job}
                    updateTempMatches={updateTempMatches}
                    tempMatchSelections={tempMatchSelections}
                  />
                ))}
              </TableBody>
            </Table>
          ) : (
            <InPlaceIndicator />
          )}
          {isSelected && (
            <Pagination
              className="survey__job-pagination"
              isSelected={isSelected}
              pageAction={pageAction}
              searchCriteria={searchCriteria}
              shouldShowInput={true}
              shouldShowMore={shouldShowMore}
              shouldShowRanges={true}
              step={STEP}
              totalCount={totalCount}
            />
          )}
        </div>
      );
    } else {
      return (
        <Placeholder
          imagePath="/view/static/mp/images/empty_results.svg"
          showText={true}
          secondaryText={secondaryText}
        />
      );
    }
  }
}

export default SurveyJobMatchingList;
